// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3H4e1","header":"Messages_header__1BNN-"};